import React from 'react';
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import footerStyle from "./style";
import { safeDeepGetWithType } from "iotera-base/json";

function Footer({ ...props }) {
  const { classes } = props;
  const lightVersion = safeDeepGetWithType(props, ["lightVersion"], false);
  if (lightVersion){
  return (
    <footer className={classes.footerLight}>
      <div className={classes.container}>
        <p className={classes.right}>
          <span style={{color: '#cdcdcd'}}>
            Copyright &copy; {1900 + new Date().getYear()}{" "}
            <a href="https://www.iotera.io" className={classes.aLight + ' text-uppercase'} target="_blank" rel="noopener noreferrer">
              Iotera
            </a>
          </span>
        </p>
      </div>
    </footer>
  ) } else
  {
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <p className={classes.right}>
          <span >
            Copyright &copy; {1900 + new Date().getYear()}{" "}
            <a href="https://www.iotera.io" className={classes.a + ' text-uppercase'} target="_blank" rel="noopener noreferrer">
              Iotera
            </a>
          </span>
        </p>
      </div>
    </footer>
  ) 
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(footerStyle)(Footer);